import $ from 'jquery';

$('.header-catalog').hover(function () {
    if (window.innerWidth >= 1000) {
        $(this).addClass('header-catalog--opened');
    }
}, function () {
    $(this).removeClass('header-catalog--opened');
    $('.overlay').removeClass('is-visible');
});

$('.header-catalog-button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (window.innerWidth >= 1000) {
        window.location.href = $(this).attr('href');
    } else {
        
        $(this).closest('.header-catalog').toggleClass('header-catalog--opened');
        $('.overlay').toggleClass('is-visible');
        $('html').toggleClass('pointer-events-none');
    }
});

$(document).on('click', function () {
    $('.header-catalog').removeClass('header-catalog--opened');
    $('.overlay').removeClass('is-visible');
    $('html').removeClass('pointer-events-none');
});

$(document).on('click', '.header-catalog__outer', function (e) {
    e.stopPropagation();
});

$('.header-catalog-section__title').click(function () {
    $(this).parents('.header-catalog-section').toggleClass('header-catalog-section--opened');
})
